function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "places-avatar.b5524c6b",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-3",
  fill: "#070594",
  cx: 13,
  cy: 13,
  r: 13
}), /*#__PURE__*/React.createElement("g", {
  id: "map-pin",
  transform: "translate(9.000000, 9.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.68,4.09090909 C7.68,7.27272728 3.84,10.0000001 3.84,10.0000001 C3.84,10.0000001 0,7.27272728 0,4.09090909 C0,1.83156241 1.71922658,6.09593334e-08 3.84,6.09593334e-08 C5.96077344,6.09593334e-08 7.68,1.83156241 7.68,4.09090909 Z M3.84,5.45454546 C4.54692448,5.45454546 5.12,4.84402466 5.12,4.09090909 C5.12,3.33779352 4.54692448,2.72727273 3.84,2.72727273 C3.13307552,2.72727273 2.56,3.33779352 2.56,4.09090909 C2.56,4.84402466 3.13307552,5.45454546 3.84,5.45454546 Z",
  id: "Combined-Shape"
}))));

function SvgLugares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "places-avatar.b5524c6b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLugares);
export default __webpack_public_path__ + "static/media/lugares.0d2f33c7.svg";
export { ForwardRef as ReactComponent };